import { render, staticRenderFns } from "./ViewRouterSwitch.vue?vue&type=template&id=2abc3810&scoped=true&"
import script from "./ViewRouterSwitch.ts?vue&type=script&lang=ts&"
export * from "./ViewRouterSwitch.ts?vue&type=script&lang=ts&"
import style0 from "./ViewRouterSwitch.vue?vue&type=style&index=0&id=2abc3810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc3810",
  null
  
)

export default component.exports